var exports = {
  "PT": "Markup.module__markup___UWpPcm",
  "z3": "Markup.module__bio___UWpPcm",
  "Z_": "Markup.module__mutedSpoilerContext___UWpPcm",
  "nf": "Markup.module__link___UWpPcm",
  "mG": "Markup.module__inline___UWpPcm",
  "tZ": "Markup.module__inlineFormat___UWpPcm",
  "Hy": "Markup.module__codeContainer___UWpPcm",
  "h": "Markup.module__blockquoteContainer___UWpPcm",
  "xE": "Markup.module__alert___UWpPcm",
  "CZ": "Markup.module__tableContainer___UWpPcm",
  "js": "Markup.module__latexCodeBlock___UWpPcm",
  "lB": "Markup.module__codeActions___UWpPcm",
  "vo": "Markup.module__codeActionsVisible___UWpPcm",
  "r": "Markup.module__blockquoteDivider___UWpPcm",
  "rs": "Markup.module__blockquoteContent___UWpPcm",
  "em": "Markup.module__blockquoteEmptyContent___UWpPcm",
  "tp": "Markup.module__table___UWpPcm",
  "qd": "Markup.module__tableHeader___UWpPcm",
  "xR": "Markup.module__tableCell___UWpPcm",
  "Vl": "Markup.module__alignLeft___UWpPcm",
  "Hu": "Markup.module__alignCenter___UWpPcm",
  "Wk": "Markup.module__alignRight___UWpPcm",
  "Qd": "Markup.module__alertIcon___UWpPcm",
  "Ro": "Markup.module__alertTitle___UWpPcm",
  "S9": "Markup.module__alertContent___UWpPcm",
  "FU": "Markup.module__alertNote___UWpPcm",
  "ap": "Markup.module__alertTip___UWpPcm",
  "nL": "Markup.module__alertImportant___UWpPcm",
  "vc": "Markup.module__alertWarning___UWpPcm",
  "SN": "Markup.module__alertCaution___UWpPcm",
  "lE": "Markup.module__mention___UWpPcm",
  "bG": "Markup.module__interactive___UWpPcm",
  "vE": "Markup.module__timestamp___UWpPcm",
  "CU": "Markup.module__spoilerWrapper___UWpPcm",
  "N5": "Markup.module__blockSpoilerWrapper___UWpPcm",
  "p6": "Markup.module__spoiler___UWpPcm",
  "mC": "Markup.module__blockSpoiler___UWpPcm",
  "ur": "Markup.module__spoilerContent___UWpPcm",
  "yI": "Markup.module__latexContent___UWpPcm",
  "Y4": "Markup.module__hljs___UWpPcm",
  "HQ": "Markup.module__ansiCode___UWpPcm",
  "bi": "Markup.module__ansi-code-blink___UWpPcm",
  "So": "Markup.module__error___UWpPcm",
};

module.exports = exports;
